import React, { Component } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import { getEvents } from "./Events";
import 'react-big-calendar/lib/css/react-big-calendar.css';

const localizer = momentLocalizer(moment); // or globalizeLocalizer

export default class CalendarComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      events: []
    };
  };

componentDidMount() {
    getEvents(events => {
        this.setState({ events });
    });
  };
  render () {
    return (
        <div className="calendar">
          <Calendar
            localizer={localizer}
            events={this.state.events}
            startAccessor="start"
            endAccessor="end"
            defaultView="month"
            culture="eng"
            style={{ margin: "auto", padding: "30px", height: 700, width: 1000, backgroundColor: "rgba(101, 117, 140, 0.7)", borderRadius: "20px"}}
          />
        </div>
    );
  }
}


